/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maintenance_Pre_ReplaceInputs */



/**
* | output |
* | --- |
* | "Pre-replace" |
*
* @param {Maintenance_Pre_ReplaceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const maintenance_pre_replace = /** @type {((inputs?: Maintenance_Pre_ReplaceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maintenance_Pre_ReplaceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pre-replace")
	return /** @type {LocalizedString} */ ("Pré-remplacer")
});